export default {
  cookies: {
    weUseCookies: 'Utilizziamo i cookie nella fornitura dei nostri servizi.',
    learnMoreStart: 'Per conoscere i cookie che utilizziamo e informazioni sulle tue preferenze e scelte di opt-out, fai ',
    learnMoreClickHere: 'clic qui',
    learnMoreEnd: '.',
    decline: 'Declino',
    allow: 'Permettere',
    showPrivacyPolicy: "Mostra l'informativa sulla privacy"
  }
};